/* OSKA_FIXES_20261025C
   - Dil asistani: konusarak algila artik yayinda olmayan dillerde (RU/AR/DE/ES/FR/ZH) canli asistani acar
   - Dil asistani: Fransizca butonu eklendi
   - Mikrofon (dil asistani + canli asistan): tanima dili sayfa dili (TR sayfada tr-TR), konusurken yazi canli gorunur, hata nedeni yazilir; dil adi soylenince o dile gecer, ayni dildeyse acik mesaj verir */
(function () {
  var d = document;
  function q(s, e) { return (e || d).querySelector(s); }
  function qa(s, e) { return Array.prototype.slice.call((e || d).querySelectorAll(s)); }
  function isTr() { return (d.documentElement.lang || 'tr').slice(0, 2) === 'tr'; }
  var FR = { n: 'FR · Français', h: 'Bonjour ! Parlez-moi d’OSKA, s’il vous plaît.' };

  function openAi(text) {
    var close = q('[data-oska-language-close]'); if (close) close.click();
    var open = q('[data-oska-concierge-open-top]') || q('[data-oska-live-chat-open]'); if (open) open.click();
    setTimeout(function () {
      var root = q('[data-oska-concierge]');
      var inp = root && q('[data-oska-chat-input]', root);
      var f = inp && inp.form;
      if (!inp || !f) return;
      inp.value = text;
      if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true }));
    }, 450);
  }

  function addFr() {
    if (window.oskaLocaleOn && window.oskaLocaleOn('fr')) return;
    qa('.oska-language-quick').forEach(function (box) {
      if (box.querySelector('[data-oska-language-code="fr"]')) return;
      var b = d.createElement('button');
      b.type = 'button'; b.dataset.oskaLanguageCode = 'fr';
      b.appendChild(d.createTextNode(FR.n + ' '));
      var s = d.createElement('small'); s.textContent = isTr() ? 'canlı asistan' : 'live assistant'; b.appendChild(s);
      box.appendChild(b);
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { addFr(); setTimeout(addFr, 900); });
  else { addFr(); setTimeout(addFr, 900); }

  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.oska-language-quick [data-oska-language-code="fr"]');
    if (!b) return;
    if (window.oskaLocaleOn && window.oskaLocaleOn('fr')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    try { if (window.speechSynthesis) speechSynthesis.cancel(); } catch (x) {}
    openAi(FR.h);
  }, true);

  var Rec = window.SpeechRecognition || window.webkitSpeechRecognition;
  function detect(s) {
    s = (s || '').trim();
    if (/[؀-ۿ]/.test(s)) return 'ar';
    if (/[一-鿿]/.test(s)) return 'zh';
    if (/[Ѐ-ӿ]/.test(s)) return 'ru';
    var l = s.toLocaleLowerCase();
    if (/[çğıöşü]/.test(l) || /\b(merhaba|selam|kadın|erkek|yüzük|bileklik|kolye|küpe|üretim|teklif|teşekkür)\b/.test(l)) return 'tr';
    if (/[äöüß]/.test(l) || /\b(hallo|guten|danke|schmuck|armband|kette|ohrringe)\b/.test(l)) return 'de';
    if (/[àâèêëîïôûœ]/.test(l) || /\b(bonjour|merci|bijoux|bague|collier|boucles)\b/.test(l)) return 'fr';
    if (/[áéíóúñ¿¡]/.test(l) || /\b(hola|gracias|joyas|anillo|collar|pulsera|pendientes)\b/.test(l)) return 'es';
    return 'en';
  }

  function byName(t) {
    var l = (t || '').toLocaleLowerCase('tr');
    if (/ingilizce|english|inglés|anglais|englisch/.test(l)) return 'en';
    if (/almanca|deutsch|german|alemán|allemand/.test(l)) return 'de';
    if (/ispanyolca|español|spanish|espagnol|spanisch/.test(l)) return 'es';
    if (/fransızca|français|french|francés|französisch/.test(l)) return 'fr';
    if (/rusça|русский|russian|ruso|russe|russisch/.test(l)) return 'ru';
    if (/arapça|arabic|العربية|árabe|arabe|arabisch/.test(l)) return 'ar';
    if (/çince|chinese|中文|chino|chinois|chinesisch/.test(l)) return 'zh';
    if (/türkçe|turkish|türkisch|turco|turc/.test(l)) return 'tr';
    return '';
  }

  /* Ortak: tanima dili. Turkce sayfada tr-TR (tarayici dili Ingilizce olsa bile) */
  var LMAP = { tr: 'tr-TR', de: 'de-DE', es: 'es-ES', fr: 'fr-FR', ru: 'ru-RU', ar: 'ar-SA', zh: 'zh-CN' };
  function recLang() {
    var p = (d.documentElement.lang || 'tr').slice(0, 2).toLowerCase();
    if (LMAP[p]) return LMAP[p];
    var n = navigator.language || '';
    return /^en/i.test(n) ? n : 'en-US';
  }
  function errText(code) {
    var t = isTr();
    if (code === 'not-allowed' || code === 'service-not-allowed') return t ? 'MİKROFON İZNİ KAPALI · adres çubuğundaki kilit simgesinden izin verin' : 'MICROPHONE BLOCKED · allow it from the lock icon in the address bar';
    if (code === 'no-speech') return t ? 'SES ALGILANMADI · tekrar deneyin' : 'NO SPEECH DETECTED · try again';
    if (code === 'audio-capture') return t ? 'MİKROFON BULUNAMADI' : 'NO MICROPHONE FOUND';
    if (code === 'network') return t ? 'SES SERVİSİNE ULAŞILAMADI · internetinizi kontrol edin' : 'SPEECH SERVICE UNREACHABLE · check your connection';
    if (code === 'aborted') return '';
    return (t ? 'SESLİ ALGILAMA HATASI · ' : 'VOICE ERROR · ') + code;
  }
  function stopSpeech() { try { if (window.speechSynthesis) speechSynthesis.cancel(); } catch (x) {} }

  /* Canli asistan mikrofonu: konusurken yazi kutusuna canli yazar, bitince gonderir */
  var cRec = null;
  d.addEventListener('click', function (e) {
    var m = e.target.closest && e.target.closest('[data-oska-mic]');
    if (!m) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var root = q('[data-oska-concierge]');
    var inp = root && q('[data-oska-chat-input]', root);
    var st = root && q('[data-oska-status]', root);
    function say(t) { if (st && t) st.textContent = t; }
    function ui(on) { if (root) { root.classList.remove('is-speaking', 'is-thinking'); root.classList.toggle('is-listening', !!on); } }
    if (!Rec || !inp) { say(isTr() ? 'SESLİ GİRİŞ BU TARAYICIDA YOK' : 'VOICE INPUT NOT SUPPORTED'); return; }
    if (cRec) { try { cRec.abort(); } catch (x) {} cRec = null; ui(false); return; }
    stopSpeech();
    var got = false, errored = false, finalText = '';
    try {
      var rec = new Rec();
      cRec = rec;
      rec.lang = recLang(); rec.interimResults = true; rec.continuous = false; rec.maxAlternatives = 1;
      rec.onstart = function () { ui(true); say(isTr() ? 'DİNLİYORUM · konuşun' : 'LISTENING · speak now'); };
      rec.onresult = function (ev) {
        var interim = '';
        for (var i = ev.resultIndex; i < ev.results.length; i++) {
          var r = ev.results[i];
          if (r.isFinal) finalText += r[0].transcript; else interim += r[0].transcript;
        }
        got = true;
        inp.value = (finalText + interim).trim();
      };
      rec.onerror = function (ev) { errored = true; say(errText(ev && ev.error)); };
      rec.onend = function () {
        cRec = null; ui(false);
        var txt = (finalText || inp.value || '').trim();
        if (got && txt) {
          inp.value = txt;
          var f = inp.form;
          if (f) { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true })); }
        } else if (!errored) say(errText('no-speech'));
      };
      rec.start();
    } catch (x) { cRec = null; ui(false); say(isTr() ? 'SESLİ GİRİŞ BAŞLATILAMADI' : 'VOICE INPUT COULD NOT START'); }
  }, true);

  /* Dil asistani mikrofonu */
  d.addEventListener('click', function (e) {
    var m = e.target.closest && e.target.closest('[data-oska-language-mic]');
    if (!m) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var panel = q('[data-oska-language-panel]');
    var st = panel && q('[data-oska-language-status]', panel);
    function say(t) { if (st && t) st.textContent = t; }
    if (!Rec) { say(isTr() ? 'SESLİ ALGILAMA BU TARAYICIDA YOK' : 'VOICE DETECTION UNAVAILABLE IN THIS BROWSER'); return; }
    function route(c, t) {
      var cur = (d.documentElement.lang || 'tr').slice(0, 2);
      var nm = byName(t); if (nm) c = nm;
      var btn = panel && q('[data-oska-language-code="' + c + '"]', panel);
      say(c.toUpperCase() + ' · ' + t);
      if (c === cur) { say(c.toUpperCase() + ' · ' + t + ' — ' + (isTr() ? 'bu sayfa zaten bu dilde. Başka dil için o dilde konuşun ya da dil adını söyleyin' : 'this page is already in this language. Speak another language or say its name')); return; }
      if (btn) setTimeout(function () { btn.click(); }, 350);
      else say(c.toUpperCase() + ' · ' + (isTr() ? 'ALGILANDI' : 'DETECTED'));
    }
    stopSpeech();
    var got = false, errored = false;
    try {
      var rec = new Rec();
      rec.interimResults = true; rec.continuous = false; rec.maxAlternatives = 1;
      rec.lang = recLang();
      rec.onstart = function () { say(isTr() ? 'DİNLİYORUM · konuşun' : 'LISTENING · speak now'); };
      rec.onresult = function (ev) {
        var t = '', fin = false;
        for (var i = ev.resultIndex; i < ev.results.length; i++) { t += ev.results[i][0].transcript; if (ev.results[i].isFinal) fin = true; }
        got = true;
        if (fin) route(detect(t), t); else say('… ' + t);
      };
      rec.onerror = function (ev) { errored = true; say(errText(ev && ev.error)); };
      rec.onend = function () { if (!got && !errored) say(errText('no-speech')); };
      rec.start();
    } catch (x) { say(isTr() ? 'SESLİ ALGILAMA BAŞLATILAMADI' : 'VOICE DETECTION COULD NOT START'); }
  }, true);
})();